import {FirstAidKitItem} from "./Model/FirstAidKitData";
import {ScoreDataEmpty, ScoreDataPoints} from "../Shared/Components/Score";

export default class FirstAidKitManager {

    private readonly items: [FirstAidKitItem]

    constructor(items: [FirstAidKitItem]) {
        this.items = items
    }

    score() : ScoreDataEmpty {
        return {
            type : "empty-points"
        }
    }

}